import communicationsActions from '../actions/communications.actions';

const communicationsReducer = (state, action) => {
  switch (action.type) {
    case communicationsActions.COMMUNICATIONS_FILTER_CHANGE_SUCCESS:
      return Object.assign({}, state, {
        date: action.date,
        category: action.category,
      });
    default:
      return state;
  }
};

export default communicationsReducer;
